import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Form, Icon, Upload, notification} from 'antd';
import {getBase64, beforeUpload} from '../services/images';
import {uploadImage} from "../actions/userProfileAction";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import {saveOrUpdateMember} from "../actions/userProfileAction";
import {getLoy3AuthToken, getLoy3ProfileData, getLoy3Profile} from "../selectors/authentication";
import AvatarS4u from '../assets/img/AvatarS4u.png';

class AvatarForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(info) {
    if (info.file.status === 'uploading') {
      this.setState({loading: true});
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, () =>
        this.setState({
          loading: false,
        }),
      );
    }
  }

  uploadImage = async ({ file, onSuccess, onError }) => {
    const showUploadImageSuccess = () => {
      notification.success({
        message: this.context.t('Image uploaded'),
      });
      onSuccess('ok');
    };

    const showUploadImageError = () => {
      notification.error({
        message: this.context.t('Error while uploading image'),
      })
      onError('error');
    }

    this.setState({ loading: true })
    try {
      const updatedProfile = {
        ...this.props.loy3ProfileData,
        profilePicture:  file.name,
      };
      await this.props.uploadImage(this.props.authToken, file);
      const { success, error } = await this.props.saveOrUpdateMember(this.props.authToken, updatedProfile);

      if (success) {
        showUploadImageSuccess();
      } else if (error !== null) {
        // We only show the error if the API action didn't already display one
        showUploadImageError();
      }
    } catch (error) {
      showUploadImageError();
    }
    this.setState({ loading: false });
  };

  render() {
    if(this.props.loy3Profile == undefined) {
      return null;
    }
    // TODO understand what this assignment does and remove it!! Props should never be mutated!
    this.props.loy3Profile.profilePic = this.props.loy3ProfileData && this.props.loy3ProfileData.profilePicture ? this.props.loy3ProfileData.profilePicture : this.props.loy3Profile.profilePic

    const uploadButton = (text, icon, className) => {
      return (
        <Fragment>
          <Icon
            type={this.state.loading && className !== "mobile" ? 'loading' : icon}
            style={{
              fontSize: 18,
              color: '#d1d1d1',
              marginBottom: 4,
              marginRight: -20,
            }}
          />
          <div className="ant-upload-text">{text}</div>
        </Fragment>
      )
    };
    const hoverAvatar = (text, icon, className) => {
      return (
        <div
          className={`avatar-hover-action ${className ? className : ''} ${this.state.loading ? 'avatar-loading-action' : ''} `}
          role="button">
          {uploadButton(text, icon, className)}
        </div>
      )
    };

    const viewAvatar = (imgUrl) => (
      <Fragment>
        <div className="">
          {console.log(imgUrl)}
          <img src={imgUrl} alt=""/>
        </div>
        {hoverAvatar(this.context.t('Change Picture'), 'edit')}
      </Fragment>
    );
    return (
      <Form layout="vertical" className="form-avatar">
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          customRequest={this.uploadImage}
          beforeUpload={beforeUpload}
          onChange={this.handleChange}
        >
          {this.props.imgUrl ? viewAvatar(this.props.imgUrl || AvatarS4u) : uploadButton(this.context.t('Load Picture'), 'plus')}
          {hoverAvatar(this.context.t('Change Picture'), 'edit', 'mobile')}
        </Upload>
      </Form>

    )
  }
}

AvatarForm.propTypes = {
  imgUrl: PropTypes.string,
  saveOrUpdateMember: PropTypes.func.isRequired
}

AvatarForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authToken: getLoy3AuthToken(state),
  loy3ProfileData: getLoy3ProfileData(state),
  loy3Profile: getLoy3Profile(state),
});

const mapDispatchToProps = (dispatch) => ({
  uploadImage: (authToken, file) => uploadImage(authToken, file)(dispatch),
  saveOrUpdateMember: (authToken, values) => saveOrUpdateMember(authToken, values)(dispatch)
});
const WrappedRegistrationForm = Form.create({name: 'avatarForm'})(AvatarForm);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedRegistrationForm));
